import * as React from "react";
const SvgFiRrNarwhal = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-narwhal_svg__a)">
      <path
        fill="#062147"
        d="M19 16.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m5-.499c0 4.411-3.588 8-7.999 8H8.727C3.915 24 0 20.084 0 15.272c0-3.367.987-6.628 2.855-9.43l.493-.74A5.58 5.58 0 0 1 .004.65C-.038.3.235-.023.586.002 4.253.262 5.5 2.775 5.5 2.775S6.703.26 10.414.001c.351-.024.624.3.582.65a5.57 5.57 0 0 1-4.129 4.72l-.463 2.746a29 29 0 0 0-.377 3.594c2.872-2.379 5.88-3.71 8.474-3.71h1.864v.008a8 8 0 0 1 1.8.29L22.877.297a.602.602 0 0 1 1.102.466l-2.56 9.36A7.98 7.98 0 0 1 24 16.001m-2 0a6.006 6.006 0 0 0-5.993-5.999C15.693 9.996 15.255 10 14.5 10c-2.559 0-5.845 1.76-8.793 4.707A1 1 0 0 1 4 14v-1.059c0-1.725.146-3.459.432-5.156l.158-.939C2.942 9.32 2 12.303 2 15.274a6.735 6.735 0 0 0 6.727 6.727h7.274a6.006 6.006 0 0 0 6-5.999"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-narwhal_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrNarwhal;
